import React from 'react';
import ChangePasswordForm from '../components/resuableComponents/ChangePasswordForm';

const ChangePassword = () => {
	return (
		<div>
			<ChangePasswordForm />>
		</div>
	);
};

export default ChangePassword;
